import React from "react";
import PropTypes from "prop-types";

import "./styles.scss";

const Header = ({ title, subtitle, className = "" }) => (
  <div className={className}>
    <h6>{title}</h6>
    <h4>{subtitle}</h4>
  </div>
);

Header.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
};

export default Header;
